import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import GoogleBingUAT from "./GoogleBingUAT";

const GoogleBingUATList = ({ data, setData, onEdit }) => {
  // Destructure data from props
  const appUrl = process.env.REACT_APP_BACKEND_APP_HOST;

  const statusChange = (e, id) => {
    const isChecked = e.target.checked; // Get the current checked status
    const updatedStatus = isChecked ? "1" : "0";

    // Optimistically update the UI by changing the local data state immediately
    setData((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, status: updatedStatus } : item
      )
    );

    // Send the updated status to the server
    axios
      .put(`${appUrl}/bing/changestatus/${id}`, {
        id: id,
        status: updatedStatus,
      })
      .then((response) => {
        console.log("Status updated successfully:", response.data);
        Swal.fire({
          icon: "success", // Lowercase "success"
          title: "Updated!",
          text: "Status updated successfully!",
          confirmButtonText: "Ok",
        });
      })
      .catch((error) => {
        console.error("Error updating status:", error);

        // Revert the UI if the API call fails
        setData((prevItems) =>
          prevItems.map((item) =>
            item.id === id
              ? { ...item, status: item.status === "1" ? "0" : "1" }
              : item
          )
        );
      });
  };

  const handleDelete = async (id) => {
    // Show a confirmation dialog before proceeding with the deletion
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    // If the user confirms the deletion
    if (result.isConfirmed) {
      try {
        // Make a DELETE request to your API
        await axios.delete(`${appUrl}/bing/delete/${id}`); // Replace with your actual delete URL

        // Update state to remove the deleted item
        setData((prevData) => prevData.filter((item) => item.id !== id));

        // Show success alert
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Record deleted successfully!",
          confirmButtonText: "Ok",
        });
      } catch (error) {
        console.error("Error deleting item:", error);

        // Show error alert
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "There was an issue deleting the record. Please try again.",
          confirmButtonText: "Ok",
        });
      }
    }
  };

  return (
    <div className="pixel-screen-wrapper1">
      <div className="main-container">
        <table>
          <thead>
            <tr>
              <th>Status</th>
              <th>Product Id</th>
              <th>Shop Url</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((val, ind) => (
              <tr key={val.id}>
                <td key={val.id}>
                  <input
                    type="checkbox"
                    id={`switch-${ind}`}
                    className="checkbox"
                    checked={val.status == 1} // Check if the status is '1'
                    onChange={(e) => statusChange(e, val.id)}
                  />
                  <label htmlFor={`switch-${ind}`} className="toggle"></label>
                </td>
                <td>{val.id}</td>
                <td>{val.shop_url}</td>
                <td>
                  <Link to="#" onClick={() => handleDelete(val.id)}>
                    <i className="bi bi-trash3-fill"></i>
                  </Link>
                  <Link to="#" onClick={() => onEdit(val)}>
                    <i className="bi bi-gear-fill"></i>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GoogleBingUATList;
